import themes from "./_Generated/themeValues";

import { ObservableValue } from "azure-devops-ui/Core/Observable";

import { announce } from "azure-devops-ui/Core/Util/Accessibility";

let themeElement: HTMLStyleElement | undefined;

export const defaultThemeId = "ms.vss-web.theme";
export const darkThemeId = "ms.vss-web.theme-dark";

let currentThemeId: string | null = null;
try {
    currentThemeId = window.localStorage.getItem("current-theme");
} catch (ex) {
    // Could not read from local storage
}

/**
 * Gets/sets the current user theme
 */
export const currentUserTheme = new ObservableValue(currentThemeId || defaultThemeId);
currentUserTheme.subscribe(themeId => {
    try {
        window.localStorage.setItem("current-theme", themeId);
    } catch (ex) {
        // Could not read from local storage
    }

    applyTheme(themeId);
});

/**
 * Toggle between light/dark themes
 */
export function toggleTheme() {
    const newTheme = currentUserTheme.value === darkThemeId ? defaultThemeId : darkThemeId;
    currentUserTheme.value = newTheme;
    if (newTheme === darkThemeId) {
        announce("Switched to a dark theme");
    } else {
        announce("Switched to a light theme");
    }
}

function dispatchEvent(eventName: string, params: any) {
    const global = window as any;

    let evt;
    if (typeof global.CustomEvent === "function") {
        evt = new global.CustomEvent(eventName, params);
    } else {
        params = params || { bubbles: false, cancelable: false };
        evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(eventName, params.bubbles, params.cancelable, params.detail);
    }

    window.dispatchEvent(evt);
}

export function getThemeValues(themeId?: string) {
    const theme = themeId || currentUserTheme.value;
    return themes[theme] || themes[defaultThemeId];
}

export function applyTheme(themeId: string) {
    const themeValues = getThemeValues(themeId);

    if (!themeElement) {
        themeElement = document.createElement("style");
        themeElement.type = "text/css";
        document.head!.appendChild(themeElement);
    }

    const cssVariables = [];
    if (themeValues) {
        for (const varName of Object.keys(themeValues)) {
            cssVariables.push("--" + varName + ": " + themeValues[varName]);
        }
    }

    themeElement.innerText =
        ".themed, .bolt-portal-host { " + cssVariables.join("; ") + " } body, .bolt-portal-host { color: var(--text-primary-color) }";

    dispatchEvent("themeApplied", { detail: themeValues });
}
